import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useShallowSelector } from '../../lib/reduxHooks';
import BlockShelf from './BlockShelf';
import { BuilderShelfWrapper } from './builder-shelf-wrapper';

export function BlockShelfDrawer(props: React.ComponentProps<'div'>) {
  const { className, ...rest } = props;
  const state = useShallowSelector((state) => ({
    show: state.senderBuild.selectedBlocks.blockIndices.length > 0,
  }));

  return (
    <BuilderShelfWrapper
      {...rest}
      show={state.show}
      side="left"
      className={twMerge('bg-white flex flex-col', className)}
    >
      <BlockShelf />
    </BuilderShelfWrapper>
  );
}
